/**
 * @generated SignedSource<<de5a5e114e312b89a46ea47a834c86ef>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type useLocalActivityContentFragment$data = {
  readonly hasInheritedRestrictions: boolean;
  readonly hasRestrictions: boolean;
  readonly id: string | null | undefined;
  readonly properties: {
    readonly nodes: ReadonlyArray<{
      readonly id: string | null | undefined;
      readonly key: string | null | undefined;
      readonly value: string | null | undefined;
      readonly version: {
        readonly number: number | null | undefined;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly space: {
    readonly id: string | null | undefined;
    readonly key: string | null | undefined;
  } | null | undefined;
  readonly title: string | null | undefined;
  readonly " $fragmentType": "useLocalActivityContentFragment";
};
export type useLocalActivityContentFragment$key = {
  readonly " $data"?: useLocalActivityContentFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"useLocalActivityContentFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "id"
},
v1 = {
  "kind": "ScalarField",
  "name": "key"
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "useLocalActivityContentFragment",
  "selections": [
    (v0/*: any*/),
    {
      "kind": "ScalarField",
      "name": "title"
    },
    {
      "kind": "ScalarField",
      "name": "hasRestrictions"
    },
    {
      "kind": "ScalarField",
      "name": "hasInheritedRestrictions"
    },
    {
      "concreteType": "Space",
      "kind": "LinkedField",
      "name": "space",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/)
      ]
    },
    {
      "args": [
        {
          "kind": "Literal",
          "name": "keys",
          "value": [
            "emoji-title-published",
            "emoji-title-draft"
          ]
        }
      ],
      "concreteType": "PaginatedJsonContentPropertyList",
      "kind": "LinkedField",
      "name": "properties",
      "plural": false,
      "selections": [
        {
          "concreteType": "JsonContentProperty",
          "kind": "LinkedField",
          "name": "nodes",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            {
              "kind": "ScalarField",
              "name": "value"
            },
            (v1/*: any*/),
            {
              "concreteType": "Version",
              "kind": "LinkedField",
              "name": "version",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "number"
                }
              ]
            }
          ]
        }
      ],
      "storageKey": "properties(keys:[\"emoji-title-published\",\"emoji-title-draft\"])"
    }
  ],
  "type": "Content"
};
})();

(node as any).hash = "e057d047fb173be62229acfca15ccbce";

export default node;
